export { default } from './PdfCard';
